import React, { useCallback, useState } from 'react';
import { useSelector } from '../../redux';
import GuestGatewayModal from './GuestGatewayModal';
import { FreeTrialDialog } from './FreeTrialDialog';
import { FreeTrialScrollToTop } from './FreeTrialScrollToTop';
import { usePopupBanners } from './usePopupBanners';
import { AgeVerifyModal } from 'src/client/components/modals/AgeVerifyModal';
import { HIDE_GUEST_GATEWAY_COOKIE } from 'src/shared/constants/cookies';
import { useShowSfwSite } from 'src/client/helpers/useFeatureFlags';
import { MembersPortalFloater } from 'src/client/containers/PopupBanners/MembersPortalFloater';

const useFreeTrialDialogHook = () => {
  const [isFreeTrialDialogOpen, setFreeTrialDialogOpen] = useState(false);

  const openFreeTrialDialog = useCallback((open) => {
    setFreeTrialDialogOpen(open);
  }, []);

  const closeFreeTrialDialog = () => {
    window.dataLayer.push({
      event: 'gaEvent',
      eventCategory: 'free-trial',
      eventLabel: 'dialog',
      eventAction: 'hide',
    });
    setFreeTrialDialogOpen(false);
  };

  return {
    isFreeTrialDialogOpen,
    openFreeTrialDialog,
    closeFreeTrialDialog,
  };
};

export const PopupBanners = () => {
  const { user } = useSelector((state) => state.auth);
  const showSfwSite = useShowSfwSite();
  const [activeModal, closeActiveModal] = usePopupBanners();
  const { isFreeTrialDialogOpen, openFreeTrialDialog, closeFreeTrialDialog } = useFreeTrialDialogHook();

  const shouldRenderGuestGatewayModal = activeModal === 'showGuestGateway';
  const canShowMemberStartNow = Boolean(user && !user.validSubscription);

  const activeMember = user?.hasAnyValidSubscription || user?.hasPPSPurchase;
  const shouldShowAgeVerifyModal = Boolean(showSfwSite && user?.accountNeedsAgeVerification && activeMember);

  if (shouldShowAgeVerifyModal) {
    return <AgeVerifyModal />;
  }

  return (
    <>
      <MembersPortalFloater canShowMemberStartNow={canShowMemberStartNow} />

      <FreeTrialScrollToTop
        canShowMemberStartNow={canShowMemberStartNow}
        setFreeTrialDialogOpen={openFreeTrialDialog}
      />

      {shouldRenderGuestGatewayModal && <GuestGatewayModal onClose={closeActiveModal(HIDE_GUEST_GATEWAY_COOKIE)} />}

      <FreeTrialDialog show={isFreeTrialDialogOpen} onClose={closeFreeTrialDialog} />
    </>
  );
};
